import gql from 'graphql-tag';

const CUSTOMER_TYPES = gql`
  query Query {
    customerTypes {
      customerType
    }
  }
`;

export default CUSTOMER_TYPES;
